export const IS_BIG_MAP_MUTATION = 'IS_BIG_MAP_MUTATION';
export const IS_GRID_OR_LIST_MUTATION = 'IS_GRID_OR_LIST_MUTATION';
export const PAGE_CHANGE_MUTATION = 'PAGE_CHANGE_MUTATION';
export const SORT_UPDATE_MUTATION = 'SORT_UPDATE_MUTATION';
export const MAP_DRAWING_CHANGE_MUTATION = 'MAP_DRAWING_CHANGE_MUTATION';
export const UPDATE_LOADING_MUTATION = 'UPDATE_LOADING_MUTATION';
export const UPDATE_IS_MAP_LOADING = 'UPDATE_IS_MAP_LOADING';
export const UPDATE_SEARCH_PARAMS = 'UPDATE_SEARCH_PARAMS';
export const MAP_RESULT_UPDATE_MUTATION = 'MAP_RESULT_UPDATE_MUTATION';
export const GRID_OR_LIST_TYPE_MUTATION = 'GRID_OR_LIST_TYPE_MUTATION';
export const ACTIVE_HOUSE_MARKER_MUTATION = 'ACTIVE_HOUSE_MARKER_MUTATION';
export const REMOVE_ALL_FILTERS = 'REMOVE_ALL_FILTERS';
export const SET_SORT_CONFIGS = 'SET_SORT_CONFIGS';
export const SET_MAP_INITED = 'SET_MAP_INITED';
export const REMOVE_OUTLINE_REGION = 'REMOVE_OUTLINE_REGION';
export const MARKET_REPORT_DISPATCH = 'MARKET_REPORT_DISPATCH';
export const SET_MARKET_REPORT_DATA = 'SET_MARKET_REPORT_DATA';
export const PREV_VIEW_PATTERN_MUTATION = 'PREV_VIEW_PATTERN_MUTATION';
export const AVERAGE_DATA_MUTATION = 'AVERAGE_DATA_MUTATION';

export const SET_CENTER_POINT = 'SET_CENTER_POINT';
export const SET_ZOOM = 'SET_ZOOM';
export const PROPERTY_GATHERING_AMOUNT = 'PROPERTY_GATHERING_AMOUNT';
